import type { DayHours } from "./day-hours.type";

/** Days that share the same times: the days (1 Monday to 7 Sunday, in order) and their ranges ("HH:MM" from / to). */
export type HoursLine = { days: number[]; ranges: { from: string; to: string }[] };

/** Gathers the days of a week that have exactly the same ranges into one line each ("Monday to Thursday 09:00-12:00, 14:00-18:00"), in the order of their first day. */
export function groupWeeklyHours(days: DayHours[]): HoursLine[] {
  const lines = new Map<string, HoursLine>();
  for (const d of [...days].sort((a, b) => a.day - b.day)) {
    const key = JSON.stringify(d.ranges);
    const line = lines.get(key) ?? { days: [], ranges: d.ranges };
    line.days.push(d.day);
    lines.set(key, line);
  }
  return [...lines.values()];
}
